module.exports = __webpack_public_path__ + "img/join-bg (7).128ea76f.jpg";